export default "__VITE_ASSET__V2r96qg6__"